import React from "react";

import classes from "./HomeV2.module.css";

const HomeV2 = () => {
    return (
        <section id="inicio" className={classes.home}
            style={{
                backgroundImage: "url('/img/home.png')"
            }}>
            <div className={classes.grid}>
                <div className={classes.primerCuadrante}>
                    <h2 className={classes.tituloG}>
                        <span className={classes.masGrande}>
                            Más
                        </span> que <br></br> publicidad,
                    </h2>
                    <p className={classes.descripcion}>Creamos canales de comunicación que <br />
                        conectan marcas con su público, mediante <br />
                        tecnología, publicidad y activaciones, <br />
                        adaptándonos a sus necesidades y <br />
                        presupuesto
                    </p>
                </div>
                <div className={classes.cuadrante}>
                </div>
                <div className={classes.tercerCuadrante}>
                    <svg className={classes.icon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
                    </svg>
                </div>
                <div className={classes.cuartoCuadrante}>
                <h2 className={classes.tituloG}>
                        Generamos <br></br>
                        <span className={`${classes.masGrande} ${classes.espejo}`}>
                            IMPACTO
                        </span>
                    </h2>
                </div>
            </div>
        </section>
    );
};

export default HomeV2;